import validator from 'validator'

const customURLValidator = value => {
  if (!value) {
return true
}

  return validator.isURL(value)
}

export default customURLValidator
